import React, { useState, useEffect } from "react";

import Autocomplete from "../ui/Autocomplete";
import NuxeoClient from "../../clients/NuxeoClient";

import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import InputLabel from "@material-ui/core/InputLabel";

import { useI18n } from "../../I18nProvider";

export default function TierOfDistribution(props) {
  const appText = useI18n();
  const [fetchedTierOfDistribution, setFetchedTierOfDistribution] = useState(
    []
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    _loadTierOfDistribution();
  }, []);

  async function _loadTierOfDistribution() {
    await NuxeoClient.instance()
      .fetchTierOfDistribution()
      .then((response) => {
        setFetchedTierOfDistribution(response);
        setIsLoading(false);
      });
  }

  const handleChange = (values) => {
    if (values === null) {
      props.handleChange("tierOfDistribution", []);
    } else {
      let result = values.map((value) => value.label);
      props.handleChange("tierOfDistribution", result);
    }
  };

  return (
    // <Tooltip arrow title="Please select the tier of distribution(s)">
    <Tooltip arrow title={appText.T118}>
      <Grid item={true} xs={12}>
        <div id="tierOfDistribution">
          <InputLabel className="field-label field-dropdown" required>
            {appText.T55}
          </InputLabel>
          <Autocomplete
            type={"multi"}
            handleChange={handleChange}
            data={fetchedTierOfDistribution}
            dataType={"tierOfDistribution"}
            mapVariable={"label"}
            setFilterData={() => null}
            value={props.value}
            isLoading={isLoading}
          />
        </div>
      </Grid>
    </Tooltip>
  );
}
